var _require = require("./errorHandler/util"),
    errorWrap = _require.errorWrap,
    responseWrap = _require.responseWrap;

var _require2 = require("./errorHandler/handler"),
    handler = _require2.handler;

var _require3 = require("./errorHandler/errorType"),
    requestErrors = _require3.requestErrors,
    responseErrors = _require3.responseErrors,
    RPCErrors = _require3.RPCErrors,
    otherErrors = _require3.otherErrors;

exports.TierError = {
  errorHandler: handler,
  ErrorType: {
    requestErrors: requestErrors,
    responseErrors: responseErrors,
    RPCErrors: RPCErrors,
    otherErrors: otherErrors
  },
  ErrorUtil: {
    errorWrap: errorWrap,
    responseWrap: responseWrap
  }
};